<div class="main-card">

  <div class="card-header">
    <div class="card-actions">
      <ion-button class="app-large-btn" shape="round" fill="outline" color="primary" (click)='addcategory()'>
        <ion-icon slot=start color="primary" name='add-circle-outline'>
        </ion-icon>
        {{ 'add_category' | translate }}
      </ion-button>
      <ion-button class="right-margin-30" shape="round" fill="outline" color="primary" (click)='addpictogramimages()'>
        <ion-icon slot=start color="primary" name='add-circle-outline'>
        </ion-icon>
        {{ 'add_pictogram_images_title' | translate }}
      </ion-button>
    </div>
  </div>

  <div class="card-body">
    <div class="no-data-container" *ngIf="isPictogramCategoriesLoaded && (!pictogramcategoriesData || pictogramcategoriesData.length === 0)">
      <img src="assets/images/Nodataicon.svg" alt="no data" class="no-data-icon" />
      <!-- OR if it is an ion-icon -->
      <p class="no-data-text">{{ 'no_data_available' | translate }}</p>
    </div>



    <ion-accordion-group *ngIf="pictogramcategoriesData && pictogramcategoriesData.length > 0">

      <ion-accordion *ngFor="let category of pictogramcategoriesData">

        <!-- Accordion Header -->
        <ion-item slot="header" lines="none">
          <ion-label>{{ category.name }}</ion-label>
          <div class="accordion-actions" slot="end">
            <!-- Edit Icon -->
            <span tabindex="0" role="button" class="more-icon more-icon--edit"
              (keydown.enter)="onEditCategory(category, $event)"
              (click)="onEditCategory(category, $event)"
              tooltip="{{'Edit' | translate }}" placement="bottom"></span>
            <!-- Delete Icon -->
            <span tabindex="0" role="button" class="more-icon  more-icon--delete"
              (keydown.enter)="onDeleteCategory(category, $event)"
              (click)="onDeleteCategory(category, $event)" tooltip="{{'Delete' | translate }}"
              placement="bottom"></span>
          </div>
        </ion-item>

        <!-- Accordion Content -->
        <div class="accordion-content" slot="content">


          <div *ngIf="isPictogramCategoriesLoaded && (!category.images || category.images.length === 0)" class="no-data">
            {{ 'no_data_available' | translate }}
          </div>


          <div class="image-card" *ngFor="let img of category.images; let i = index">

            <!-- Image -->
            <div class="image-wrapper">
              <img [src]="img.url" alt="image" />
              <!-- Delete Icon -->
              <div class="delete-icon" (click)="onDeleteCategoryImage(img)">
                <ion-icon class="close-icon" name="close-circle-outline"></ion-icon>
              </div>
            </div>

            <!-- File Name — ion-input -->
            <ion-input class="img-name-input" (mouseleave)="onImageCardMouseLeave(img, category)" [(ngModel)]="img.displayName"
              [name]="'fileName-' + (img.url || i)" maxlength="100" [placeholder]="img.fileName"
              (ionFocus)="onNameFocus(img)" (ionBlur)="onNameBlur(img, category)" (click)="$event.stopPropagation()">
            </ion-input>

          </div>

        </div>

      </ion-accordion>

    </ion-accordion-group>

  </div>

</div>